import "../../styles/auth/auth.css";

const AuthSubmitButton = (props = {}) => {
  const { loading, verifying, resending, disabledText, text } = props;

  return (
    <button
      type="submit"
      className="auth-button"
      disabled={loading || verifying || resending}
    >
      {loading || verifying ? disabledText : text}
    </button>
  );
};

export default AuthSubmitButton;
